import { IndexLayout } from '@web/home/layout';
import { ReactNode } from 'react';

export const getIndexLayout = (page: ReactNode) => <IndexLayout>{page}</IndexLayout>;
